export const setupOnboarding = {
  piezas: {
    confirmacion: { etiqueta: "Conferma", larga: "Conferma di prenotazione", porque: "Si sta usando l'impostazione generale del tuo account, non una propria di questo alloggio." },
    bienvenida: { etiqueta: "Benvenuto", larga: "Messaggio di benvenuto", porque: "Al momento parte il messaggio di benvenuto predefinito, che non è il tuo." },
    checkin: { etiqueta: "Check-in", larga: "Invio del check-in", porque: "Al momento parte all'ora predefinita, che potrebbe non esserti comoda." },
    horas: { etiqueta: "Orari", larga: "Orario di arrivo e partenza", porque: "Senza i tuoi orari, all'ospite che chiede si risponde con quelli predefiniti." },
    cerradura: { etiqueta: "Accesso", larga: "Serratura e accesso", porque: "L'ospite arriva alla porta e non sa come aprire." },
    servicios: { etiqueta: "Servizi", larga: "Servizi dell'alloggio", porque: "Né il motore di prenotazione né l'agente sanno cosa offri." },
    politicas: { etiqueta: "Regole", larga: "Politiche e regole", porque: "L'ospite accetta regole predefinite, non le tue." },
  },
  titular: {
    listo: "È tutto pronto",
    unoAMedias: "Il tuo alloggio è configurato a metà",
    variosAMedias: "I tuoi alloggi sono configurati a metà",
    casi: "Ti manca poco",
  },
  consecuencia: {
    bienvenida: "Nel frattempo i tuoi ospiti ricevono il messaggio di benvenuto predefinito, che non è il tuo.",
    cerradura: "Nel frattempo ci sono ospiti che arriverebbero alla porta senza sapere come aprire.",
    politicas: "Nel frattempo i tuoi ospiti accettano regole predefinite, non le tue.",
    generico: "Nel frattempo si usano le impostazioni predefinite, non le tue.",
  },
  explicacion: {
    listoUno: "Il tuo alloggio può già ricevere ospiti.",
    listoVarios: "I tuoi {n} alloggi possono già ricevere ospiti.",
    ajustesFinos: "Le impostazioni di dettaglio — tariffe, canali, esperienze — ti aspettano in ogni annuncio quando vuoi.",
    faltaUno: "Manca 1 alloggio da completare.",
    faltanVarios: "Mancano {n} alloggi da completare.",
  },
  resumen: {
    unAlojamiento: "1 alloggio",
    nAlojamientos: "{n} alloggi",
    unoPorPreparar: "1 da preparare",
    nPorPreparar: "{n} da preparare",
    listos: "{listos} pronti",
  },
  anillo: {
    rotulo: "configurato",
    ariaCorta: "{n}% configurato",
    ariaLarga: "{n}% della configurazione completata",
  },
  cifras: {
    listos: "pronti ·",
    ajustes: "impostazioni fatte",
    ariaAjustes: "{hechas} di {total} impostazioni fatte",
    marcador: "{hechas} di {total}",
  },
  ventana: {
    titulo: "Chiudere questo avviso?",
    texto: "Non comparirà più nel pannello, anche se ti resta qualcosa da configurare.",
    notaAntes: "Lo recuperi quando vuoi da",
    notaRuta: "Personalizza → Mostra l'avviso di configurazione",
    cancelar: "Annulla",
    ocultar: "Chiudi",
  },
  acciones: {
    verQueFalta: "Vedi cosa manca",
    buscar: "Cerca alloggio",
    sinResultados: "Nessun alloggio in sospeso si chiama così.",
    verClaro: "Passa al chiaro",
    verOscuro: "Passa allo scuro",
    ampliar: "Ingrandisci",
    ampliarAria: "Ingrandisci l'avviso",
    minimizar: "Riduci",
    minimizarAria: "Riduci l'avviso",
    entendido: "Ho capito",
    entendidoAria: "Ho capito, chiudi l'avviso",
    ocultar: "Chiudi",
    ocultarAria: "Chiudi l'avviso di configurazione",
    empezar: "Inizia",
    continuar: "Continua",
    hecho: "fatto",
    teToca: "Tocca a te:",
    unidades: "{n} unità",
  },
};
